<template>
    <td-dialog :title="title" :before-close="postDialogClose" :visible.sync="dialogPostVisible" width="320px" :close-on-click-modal="false" :close-on-press-escape="false" top="18vh">
        <el-form :model="formPostInfo" ref="formPostInfo" label-width="80px" :rules="rules" style="margin-bottom:10px;">
            <el-form-item :label="$t('pgCommon.POST_CAPTION')" prop="postName">
                <td-input v-model="formPostInfo.postName" maxlength="12"></td-input>
            </el-form-item>
            <el-form-item :label="$t('pgCommon.POST_RANK')" prop="rank">
                <td-select v-model="formPostInfo.rank" :placeholder="$t('common.PLEASE_SELECT')" :options="this.rankList" keys="value" text="label" :clearable="false"> </td-select>
            </el-form-item>
            <el-form-item :label="$t('pgCommon.DESCRIPTION')" prop="description">
                <td-input type="textarea" v-model="formPostInfo.description" :maxlength="100"></td-input>
            </el-form-item>
        </el-form>
        <span slot="footer">
            <td-button type="primary" @click="submitForm('formPostInfo')" :loading="loading">{{ $t('pgCommon.SAVE') }}</td-button>
            <td-button type="button" @click.native="postDialogClose">{{ $t('pgCommon.CANCEL') }}</td-button>
        </span>
    </td-dialog>
</template>
<script>
import resourceApi from '../assets/api.js';
export default {
    // 初始化渲染
    components: {},
    props: ['title', 'dialogPostVisible', 'editItem', 'isAddData'],
    created() {
        // 为编辑状态则进行初始化数据
        if (!this.isAddData) {
            this.initEditData();
        }
        this.getDictValuesByTag();
    },
    mounted() {},
    // 监听时间
    watch: {},
    // 定义变量
    data() {
        return {
            // Role表单信息
            hasMenuPermission: true,
            hasOrgPermission: true,
            rankList: [],
            formPostInfo: {
                postId: '',
                postName: '',
                rank: '',
                description: ''
            },
            loading: false, // 按钮是否为加载状态
            // 对表单进行数据验证
            rules: {
                postName: [
                    { required: true, message: this.$t('error.ERROR_CAPTION_NULL'), trigger: 'blur' },
                    { pattern: this.$regex.CAPTION_RULE, message: this.$t('pgRegex.PLEASE_INPUT_CREDENT_NUM_RESET') }
                ],
                description: [{ min: 1, max: 100, message: this.$t('error.ERROR_URL_MAX_LENGTH'), trigger: 'change' }]
            }
        };
    },
    // 定义并实现方法体
    methods: {
        // 初始化编辑数据
        initEditData() {
            this.formPostInfo.postId = this.editItem.sId;
            this.formPostInfo.postName = String(this.editItem.sName);
            this.formPostInfo.description = String(this.editItem.sDescription);
            this.formPostInfo.rank = this.editItem.sStationType;
        },
        // 提交数据
        submitForm(formName) {
            let _this = this;
            this.$refs[formName].validate(valid => {
                if (valid) {
                    let content = {
                        sName: _this.formPostInfo.postName,
                        sStationType: _this.formPostInfo.rank,
                        sDescription: _this.formPostInfo.description
                    };
                    this.loading = true;
                    if (this.isAddData) {
                        resourceApi.addPortStation(JSON.stringify(content), response => {
                            this.loading = false;
                            if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                                this.$message({ type: 'error', showClose: true, message: response.data.statusMessage });
                                this.$log.error('resourceApi.addPortStation', response);
                                return;
                            }
                            this.$message({ showClose: true, message: this.$t('common.ADD_SUCCESS'), type: 'success' });
                            this.postDialogClose();
                            this.$emit('btnQuery');
                        });
                    } else {
                        content.sId = _this.formPostInfo.postId;
                        resourceApi.updatePortStation(JSON.stringify(content), response => {
                            this.loading = false;
                            if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                                this.$message({ type: 'error', showClose: true, message: response.data.statusMessage });
                                this.$log.error('resourceApi.updatPortStation', response);
                                return;
                            }
                            this.$message({ showClose: true, message: this.$t('common.MODIFY_SUCCESS'), type: 'success' });
                            this.postDialogClose();
                            this.$emit('btnQuery');
                        });
                    }
                }
            });
        },
        getDictValuesByTag() {
            let content = {
                sTag: 'RANK'
            };
            resourceApi.getDictValuesByTag(content, response => {
                if (response.status !== window.vue.$common.login.RESPONSE_STATUS) {
                    this.$log.error('hostApi.getDictValuesByTag', response);
                    return;
                }
                if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('hostApi.getDictValuesByTag', response.data.statusMessage);
                    return;
                }
                response.data.content.forEach(element => {
                    let param = {
                        value: element.sCode,
                        label: element.label
                    };
                    this.rankList.push(param);
                });
            });
        },
        // 关闭窗口之前需要调用的方法
        postDialogClose() {
            this.$emit('postDialogClose');
            this.$refs['formPostInfo'].resetFields(); // 重置表单数据
        }
    }
};
</script>
